import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Button, RadioGroup } from '@/ui';
import styled from 'styled-components';

export const StyledPagination = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2rem;
  margin-top: 1.5rem;
  justify-content: space-between;
`;

export const StyledPageSizeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  ${pickThemeFontStyles('16', '26')};
  color: ${pickThemeColor('BLACK')};
`;

export const StyledRadioGroup = styled(RadioGroup)`
  &.ant-radio-group {
    display: flex;
    gap: 0.5rem;

    .ant-radio-button-wrapper {
      border-radius: 0.25rem;
      border: 1px solid ${pickThemeColor('WHITE_SMOKE')};
      color: ${pickThemeColor('BLACK')};

      &::before {
        display: none;
      }

      &:hover {
        border: 1px solid ${pickThemeColor('WHITE_SMOKE')};
      }

      &.ant-radio-button-wrapper-checked {
        background-color: ${pickThemeColor('WHITE_SMOKE')};
        color: ${pickThemeColor('WHITE')};
      }
    }
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledButton = styled(Button)`
  box-shadow: 0 1px 1px 0 #00000026 !important;
  background-color: ${pickThemeColor('WHITE')};
  border: none !important;

  .anticon {
    color: ${pickThemeColor('WHITE')};

    path {
      stroke: ${pickThemeColor('BLUE')};
    }
  }

  &:disabled {
    background-color: ${pickThemeColor('WHITE')};
    color: ${pickThemeColor('GREY_DIM')};

    .anticon path {
      stroke: ${pickThemeColor('GREY_DIM')};
    }
  }
`;
